interface Props {
  targetVersion: number;
  onConfirm: (changeSummary: string) => void;
  onCancel: () => void;
}

export function RollbackConfirmDialog({ targetVersion, onConfirm, onCancel }: Props) {
  return (
    <div
      style={{
        position: 'fixed', inset: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'rgba(0,0,0,0.6)', zIndex: 1000,
      }}
      onClick={onCancel}
    >
      <div
        style={{
          background: 'var(--color-surface, #1a1b1e)', padding: 24,
          borderRadius: 12, maxWidth: 400, width: '90%',
          border: '1px solid rgba(255,255,255,0.1)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 style={{ fontFamily: 'var(--font-heading)', marginBottom: 12 }}>
          Rollback to v{targetVersion}?
        </h3>
        <p style={{ fontSize: 13, color: 'var(--color-text-muted)', marginBottom: 16 }}>
          This will create a new version with the data from v{targetVersion}.
          The current version will be preserved in the history.
        </p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button
            onClick={onCancel}
            style={{
              padding: '8px 16px', border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: 6, background: 'transparent', color: 'var(--color-text)',
              fontSize: 13, cursor: 'pointer',
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => onConfirm(`Rolled back to version ${targetVersion}`)}
            style={{
              padding: '8px 16px', border: 'none',
              borderRadius: 6, background: 'var(--color-primary)', color: '#fff',
              fontWeight: 600, fontSize: 13, cursor: 'pointer',
            }}
          >
            Confirm Rollback
          </button>
        </div>
      </div>
    </div>
  );
}
